export const footerLogoLink = "/colophon";
export default footerLogoLink;
